module.exports = __webpack_public_path__ + "img/watchdog.d08a257f.png";